import React from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import messages from "components/messagesDescription";

const errorLocalization = (error, intl) => {
  if (_.isString(error)) {
    return intl.formatMessage({ id: error, defaultMessage: error });
  } else if (error && error.message) {
    return intl.formatMessage({
      id: error.message,
      defaultMessage: error.message,
      values: error.values,
    });
  } else if (error && error.msgID) {
    const descriptor = messages.claims[error.msgID];
    return <FormattedMessage {...descriptor} values={error.values} />;
  }
};

type ErrorMessageProps = {
  error: any | string,
  intl: any,
};

export const ErrorMessage = (props: ErrorMessageProps) => {
  const { error, intl } = props;
  if (!error || error.reason === "ASK_USER_CONFIRMATION") {
    return null;
  }
  return <div className="form__alert alert alert--error">{errorLocalization(error, intl)}</div>;
};



// WEBPACK FOOTER //
// ./components/common/ErrorMessage.js